module.exports = __webpack_public_path__ + "img/capacity_bg.2dfc1318.svg";